var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Checkbox, Dimmer, Grid, Input, Loader, Menu, Message, Modal, Pagination, Popup, Table } from "semantic-ui-react";
import { debounce } from "../kit/automated-pro/EditKitForm";
import { RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { downloadBlob } from "../download";
import { MetaCatalogLoader } from "../kit/Catalog";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import { CatalogMode, getWithAuthn } from "../RequestHelpers";
import CreateNewColumnPurifiedProbeLotModal from "./CreateNewColumnPurifiedProbeLotModal";
import CreateNewPagePurifiedProbeLotModal from "./CreateNewPagePurifiedProbeLotModal";
import CreateNewUnpurifiedProbeLotModal from "./CreateNewUnpurifiedProbeLotModal";
import EditColumnPurifiedProbeLotModal from "./EditColumnPurifiedProbeLotModal";
import EditPagePurifiedProbeLotModal from "./EditPagePurifiedProbeLotModal";
import EditUnpurifiedProbeLotModal from "./EditUnpurifiedProbeLotModal";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import UploadFileModal from "./UploadFileModal";
var ProbeLotTablePage = /** @class */ (function (_super) {
    __extends(ProbeLotTablePage, _super);
    function ProbeLotTablePage(props) {
        var _this = _super.call(this, props) || this;
        _this.createNewPagePurifiedProbeLot = function (catalog) {
            var nextProbeLotNumber = '';
            getWithAuthn("/rna/probe-lot/next-lot-number/type/" + encodeURIComponent(ProbeLotTypeFilter.PAGE_PURIFIED))
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                nextProbeLotNumber = resp.nextLotNumber;
            });
            var renderCreateNewPagePurifiedProbeLot = function (props) {
                return React.createElement(CreateNewPagePurifiedProbeLotModal, __assign({ probeLotType: 'Catalog', nextProbeLotNumber: nextProbeLotNumber, catalog: catalog, suppliers: _this.state.suppliers }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentProbeLotPage, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'HigherFi Probe Lot' }) },
                React.createElement(Modal.Header, null, "Create New HigherFi Probe Lot"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderCreateNewPagePurifiedProbeLot, successMessage: 'Probe Lot Created' })));
        };
        _this.createNewColumnPurifiedProbeLot = function (catalog) {
            var nextProbeLotNumber = '';
            getWithAuthn("/rna/probe-lot/next-lot-number/type/" + encodeURIComponent(ProbeLotTypeFilter.COLUMN_PURIFIED))
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                nextProbeLotNumber = resp.nextLotNumber;
            });
            var renderCreateNewColumnPurifiedProbeLot = function (props) {
                return React.createElement(CreateNewColumnPurifiedProbeLotModal, __assign({ probeLotType: 'Catalog', nextProbeLotNumber: nextProbeLotNumber, catalog: catalog, suppliers: _this.state.suppliers }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentProbeLotPage, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'HiFi Probe Lot' }) },
                React.createElement(Modal.Header, null, "Create New HiFi Probe Lot"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderCreateNewColumnPurifiedProbeLot, successMessage: 'Probe Lot Created' })));
        };
        _this.createNewUnpurifiedProbeLot = function (catalog) {
            var nextProbeLotNumber = '';
            getWithAuthn("/rna/probe-lot/next-lot-number/type/" + encodeURIComponent(ProbeLotTypeFilter.UNPURIFIED))
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                nextProbeLotNumber = resp.nextLotNumber;
            });
            var renderCreateNewUnpurifiedProbeLot = function (props) {
                return React.createElement(CreateNewUnpurifiedProbeLotModal, __assign({ probeLotType: 'Catalog', nextProbeLotNumber: nextProbeLotNumber, catalog: catalog, suppliers: _this.state.suppliers }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentProbeLotPage, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'v3.0 Probe Lot' }) },
                React.createElement(Modal.Header, null, "Create New v3.0 Probe Lot"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderCreateNewUnpurifiedProbeLot, successMessage: 'Probe Lot Created' })));
        };
        _this.uploadOrderedProbeLots = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentProbeLotPage, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload Ordered Probes' }) },
                React.createElement(Modal.Header, null, "Upload Ordered Probes"),
                React.createElement(Modal.Content, null,
                    React.createElement(UploadFileModal, { path: "/rna/probe-lot/upload-ordered-probe-lots" })));
        };
        _this.uploadReceivedProbeLots = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentProbeLotPage, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload Received Probes' }) },
                React.createElement(Modal.Header, null, "Upload Received Probes"),
                React.createElement(Modal.Content, null,
                    React.createElement(UploadFileModal, { path: "/rna/probe-lot/upload-received-probe-lots" })));
        };
        _this.uploadPurifiedProbeLots = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentProbeLotPage, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload Purified Probes' }) },
                React.createElement(Modal.Header, null, "Upload Purified Probes"),
                React.createElement(Modal.Content, null,
                    React.createElement(UploadFileModal, { path: "/rna/probe-lot/upload-purified-probe-lots" })));
        };
        _this.onReorderChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    reorderFilter: !oldState.reorderFilter
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onShowPagePurifiedOnlyChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    showPagePurifiedLots: !oldState.showPagePurifiedLots,
                    showUnpurifiedLots: !oldState.showPagePurifiedLots ? false : oldState.showUnpurifiedLots,
                    showColumnPurifiedLots: !oldState.showPagePurifiedLots ? false : oldState.showColumnPurifiedLots,
                    currentPage: 1
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onShowColumnPurifiedOnlyChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    showColumnPurifiedLots: !oldState.showColumnPurifiedLots,
                    showUnpurifiedLots: !oldState.showColumnPurifiedLots ? false : oldState.showUnpurifiedLots,
                    showPagePurifiedLots: !oldState.showColumnPurifiedLots ? false : oldState.showPagePurifiedLots,
                    currentPage: 1
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onShowUnpurifiedOnlyChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    showUnpurifiedLots: !oldState.showUnpurifiedLots,
                    showPagePurifiedLots: !oldState.showUnpurifiedLots ? false : oldState.showPagePurifiedLots,
                    showColumnPurifiedLots: !oldState.showUnpurifiedLots ? false : oldState.showColumnPurifiedLots,
                    currentPage: 1
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onCollapseRowsChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    collapseRows: !oldState.collapseRows
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onShowPagePurifiedOptimizationRows = function (_) {
            _this.setState({
                showColumnPurifiedOptimizationRows: false
            });
            _this.setState(function (oldState) {
                if (!oldState.showPagePurifiedOptimizationRows) {
                    var filteredColumns_1 = _this.state.filteredColumns;
                    columnPurifiedRows.forEach(function (e) {
                        filteredColumns_1.delete(e);
                    });
                    pagePurifiedRows.forEach(function (e) {
                        filteredColumns_1.add(e);
                    });
                    return {
                        filteredColumns: filteredColumns_1,
                        showPagePurifiedOptimizationRows: !oldState.showPagePurifiedOptimizationRows,
                    };
                }
                else {
                    var filteredColumns_2 = _this.state.filteredColumns;
                    pagePurifiedRows.forEach(function (e) {
                        filteredColumns_2.delete(e);
                    });
                    return {
                        filteredColumns: filteredColumns_2,
                        showPagePurifiedOptimizationRows: !oldState.showPagePurifiedOptimizationRows
                    };
                }
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onShowColumnPurifiedOptimizationRows = function (_) {
            _this.setState({
                showPagePurifiedOptimizationRows: false
            });
            _this.setState(function (oldState) {
                if (!oldState.showColumnPurifiedOptimizationRows) {
                    var filteredColumns_3 = _this.state.filteredColumns;
                    pagePurifiedRows.forEach(function (e) {
                        filteredColumns_3.delete(e);
                    });
                    columnPurifiedRows.forEach(function (e) {
                        filteredColumns_3.add(e);
                    });
                    return {
                        filteredColumns: filteredColumns_3,
                        showColumnPurifiedOptimizationRows: !oldState.showColumnPurifiedOptimizationRows
                    };
                }
                else {
                    var filteredColumns_4 = _this.state.filteredColumns;
                    columnPurifiedRows.forEach(function (e) {
                        filteredColumns_4.delete(e);
                    });
                    return {
                        filteredColumns: filteredColumns_4,
                        showColumnPurifiedOptimizationRows: !oldState.showColumnPurifiedOptimizationRows
                    };
                }
            }, _this.loadCurrentProbeLotPage);
        };
        _this.renderColumnToggles = function (columns) {
            return React.createElement(Grid, { columns: 1, celled: 'internally' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null, columns.map(function (s, index) {
                        var onChange = function (_, data) {
                            var checked = data.checked;
                            _this.setState(function (oldState) {
                                var set = new Set(oldState.filteredColumns);
                                if (checked) {
                                    set.add(s);
                                }
                                else {
                                    set.delete(s);
                                }
                                return {
                                    filteredColumns: set
                                };
                            }, _this.loadCurrentProbeLotPage);
                        };
                        return React.createElement("div", { key: index },
                            React.createElement(Checkbox, { checked: _this.state.filteredColumns.has(s), label: s, onChange: onChange }));
                    }))));
        };
        _this.onProbeLotFilterChange = function (event, data) {
            var str = data.value;
            _this.setState(function () {
                return {
                    probeLotFilter: str,
                    currentPage: 1
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onOrganismFilterChange = function (event, data) {
            var str = data.value;
            _this.setState(function () {
                return {
                    orgFilter: str,
                    currentPage: 1
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onGeneSymbolFilterChange = function (event, data) {
            _this.setState(function () {
                return {
                    geneSymbolFilter: data.value,
                    currentPage: 1
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.onDesignNumberFilterChange = function (event, data) {
            _this.setState(function () {
                return {
                    designNumberFilter: data.value,
                    currentPage: 1
                };
            }, _this.loadCurrentProbeLotPage);
        };
        _this.renderProbeLots = function () {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Probe lot #"),
                        _this.state.filteredColumns.has("status") && React.createElement(Table.HeaderCell, null, "Status"),
                        _this.state.filteredColumns.has("organism") && React.createElement(Table.HeaderCell, null, "Organism"),
                        _this.state.filteredColumns.has("geneSymbol") && React.createElement(Table.HeaderCell, null, "Gene Symbol"),
                        _this.state.filteredColumns.has("variant") && React.createElement(Table.HeaderCell, null, "Variant"),
                        _this.state.filteredColumns.has("amplifier") && React.createElement(Table.HeaderCell, null, "HCR\u2122 Amplifier"),
                        _this.state.filteredColumns.has("probeOrderedDate") && React.createElement(Table.HeaderCell, null, "Probe Ordered Date"),
                        _this.state.filteredColumns.has("probeReceivedDate") && React.createElement(Table.HeaderCell, null, "Probe Received Date"),
                        _this.state.filteredColumns.has("probeSetSize") && React.createElement(Table.HeaderCell, null, "Probe Set Size"),
                        _this.state.filteredColumns.has("probePurifiedDate") && React.createElement(Table.HeaderCell, null, "Probe Purified Date"),
                        _this.state.filteredColumns.has("excisedBy") && React.createElement(Table.HeaderCell, null, "Quantified By"),
                        _this.state.filteredColumns.has("teAddedForResuspension") && React.createElement(Table.HeaderCell, null, "1x TE Added for Resuspension (\u00B5L)"),
                        _this.state.filteredColumns.has("dilutionBeforeQuantification") && React.createElement(Table.HeaderCell, null, "Amount Used for Dilution Before Quantification (\u00B5L)"),
                        _this.state.filteredColumns.has("dilutionFactorForQuantification") && React.createElement(Table.HeaderCell, null, "Dilution Factor for Quantification (X:1)"),
                        _this.state.filteredColumns.has("coef") && React.createElement(Table.HeaderCell, null, "Average Coefficients"),
                        _this.state.filteredColumns.has("a260OfDilutedSample") && React.createElement(Table.HeaderCell, null, "A260 of Diluted Sample"),
                        _this.state.filteredColumns.has("nanodropVolume") && React.createElement(Table.HeaderCell, null, "Nanodrop volume (ul)"),
                        _this.state.filteredColumns.has("resuspensionConcentration") && React.createElement(Table.HeaderCell, null, "Resuspension Concentration (\u00B5M)"),
                        _this.state.filteredColumns.has("purifiedConcentration") && React.createElement(Table.HeaderCell, null, "Purified Concentration (\u00B5M)"),
                        _this.state.filteredColumns.has("purifiedVolume") && React.createElement(Table.HeaderCell, null, "Purified volume (ul)"),
                        _this.state.filteredColumns.has("finalVolume") && React.createElement(Table.HeaderCell, null, "Final volume at 1.25 uM (ul)"),
                        _this.state.filteredColumns.has("targetConcentration") && React.createElement(Table.HeaderCell, null, "Target Conc (\u00B5M)"),
                        _this.state.filteredColumns.has("amountTeAdded") && React.createElement(Table.HeaderCell, null, "Amount 1x TE to Add to make Stock (\u00B5L)"),
                        _this.state.filteredColumns.has("finalConcentration") && React.createElement(Table.HeaderCell, null, "Final Concentration (\u00B5M)"),
                        _this.state.filteredColumns.has("yield") && React.createElement(Table.HeaderCell, null, "Yield (pmol)"),
                        _this.state.filteredColumns.has("currentInventory") && React.createElement(Table.HeaderCell, null, "Current Inventory (pmol)"),
                        _this.state.filteredColumns.has("validation") && React.createElement(Table.HeaderCell, null, "Validation"))),
                React.createElement(Table.Body, null, _this.state.probeLots.map(function (pl, key) {
                    // Page purified probe lots only with uncollapsed rows
                    return ((!_this.state.collapseRows && _this.state.showPagePurifiedLots) &&
                        React.createElement(React.Fragment, null,
                            React.createElement("tr", { key: key },
                                React.createElement(Table.Cell, null, _this.editProbeLot(pl, "O")),
                                _this.state.filteredColumns.has("status") && React.createElement(Table.Cell, null, pl.params.status),
                                _this.state.filteredColumns.has("organism") && ((pl instanceof CatalogPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CustomPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customOrganismName))),
                                _this.state.filteredColumns.has("geneSymbol") && ((pl instanceof CatalogPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.geneSymbol))
                                    || (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))
                                    || (pl instanceof CustomPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))),
                                _this.state.filteredColumns.has("variant") && ((pl instanceof CatalogPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.variant + '/' + pl.designNumber))
                                    || (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))
                                    || (pl instanceof CustomPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))),
                                _this.state.filteredColumns.has("amplifier") && React.createElement(Table.Cell, null, pl.hcrAmplifier.id),
                                _this.state.filteredColumns.has("probeOrderedDate") && React.createElement(Table.Cell, null, pl.params.orderedDate),
                                _this.state.filteredColumns.has("probeReceivedDate") && React.createElement(Table.Cell, null, pl.params.receivedDate),
                                _this.state.filteredColumns.has("probeSetSize") && (((pl instanceof CatalogPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.probeSetSize))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))
                                    || ((pl instanceof CustomPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))),
                                _this.state.filteredColumns.has("probePurifiedDate") && React.createElement(Table.Cell, null, _this.probePurifiedDate(pl.params)),
                                _this.state.filteredColumns.has("excisedBy") && React.createElement(Table.Cell, null, _this.excisedBy(pl.params, true)),
                                _this.state.filteredColumns.has("teAddedForResuspension") && React.createElement(Table.Cell, null, _this.resuspension(pl.params, true)),
                                _this.state.filteredColumns.has("dilutionBeforeQuantification") && React.createElement(Table.Cell, null, _this.dilutionBeforeQuantification(pl.params, true)),
                                _this.state.filteredColumns.has("dilutionFactorForQuantification") && React.createElement(Table.Cell, null, _this.dilutionFactor(pl.params, true)),
                                _this.state.filteredColumns.has("coef") && React.createElement(Table.Cell, null, _this.coef(pl.params, true)),
                                _this.state.filteredColumns.has("a260OfDilutedSample") && React.createElement(Table.Cell, null, _this.a260(pl.params, true)),
                                _this.state.filteredColumns.has("nanodropVolume") && React.createElement(Table.Cell, null, _this.nanodropVolume(pl.params)),
                                _this.state.filteredColumns.has("resuspensionConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params, true)),
                                _this.state.filteredColumns.has("purifiedConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params, true)),
                                _this.state.filteredColumns.has("purifiedVolume") && React.createElement(Table.Cell, null, _this.purifiedVolume(pl.params)),
                                _this.state.filteredColumns.has("finalVolume") && React.createElement(Table.Cell, null, _this.finalVolume(pl.params)),
                                _this.state.filteredColumns.has("targetConcentration") && React.createElement(Table.Cell, null, _this.targetConc(pl.params, true)),
                                _this.state.filteredColumns.has("amountTeAdded") && React.createElement(Table.Cell, null, _this.amountTeAdded(pl.params, true)),
                                _this.state.filteredColumns.has("finalConcentration") && React.createElement(Table.Cell, null, _this.finalConcentration(pl.params, true)),
                                _this.state.filteredColumns.has("yield") && React.createElement(Table.Cell, null, _this.yield(pl.params, true)),
                                _this.state.filteredColumns.has("currentInventory") && React.createElement(Table.Cell, null, _this.currentInventory(pl.params, true)),
                                _this.state.filteredColumns.has("validation") && React.createElement(Table.Cell, null, pl.validation)),
                            React.createElement("tr", { key: key },
                                React.createElement(Table.Cell, null, _this.editProbeLot(pl, "E")),
                                _this.state.filteredColumns.has("status") && React.createElement(Table.Cell, null, pl.params.status),
                                _this.state.filteredColumns.has("organism") && (((pl instanceof CatalogPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.organism))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.organism))
                                    || ((pl instanceof CustomPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customOrganismName))),
                                _this.state.filteredColumns.has("geneSymbol") && (((pl instanceof CatalogPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.geneSymbol))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customGeneSymbolName))
                                    || ((pl instanceof CustomPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customGeneSymbolName))),
                                _this.state.filteredColumns.has("variant") && (((pl instanceof CatalogPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.variant + '/' + pl.designNumber))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customVariantName))
                                    || ((pl instanceof CustomPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customVariantName))),
                                _this.state.filteredColumns.has("amplifier") && React.createElement(Table.Cell, null, pl.hcrAmplifier.id),
                                _this.state.filteredColumns.has("probeOrderedDate") && React.createElement(Table.Cell, null, pl.params.orderedDate),
                                _this.state.filteredColumns.has("probeReceivedDate") && React.createElement(Table.Cell, null, pl.params.receivedDate),
                                _this.state.filteredColumns.has("probeSetSize") && (((pl instanceof CatalogPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.probeSetSize))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))
                                    || ((pl instanceof CustomPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))),
                                _this.state.filteredColumns.has("probePurifiedDate") && React.createElement(Table.Cell, null, _this.probePurifiedDate(pl.params)),
                                _this.state.filteredColumns.has("excisedBy") && React.createElement(Table.Cell, null, _this.excisedBy(pl.params, false)),
                                _this.state.filteredColumns.has("teAddedForResuspension") && React.createElement(Table.Cell, null, _this.resuspension(pl.params, false)),
                                _this.state.filteredColumns.has("dilutionBeforeQuantification") && React.createElement(Table.Cell, null, _this.dilutionBeforeQuantification(pl.params, false)),
                                _this.state.filteredColumns.has("dilutionFactorForQuantification") && React.createElement(Table.Cell, null, _this.dilutionFactor(pl.params, false)),
                                _this.state.filteredColumns.has("coef") && React.createElement(Table.Cell, null, _this.coef(pl.params, false)),
                                _this.state.filteredColumns.has("a260OfDilutedSample") && React.createElement(Table.Cell, null, _this.a260(pl.params, false)),
                                _this.state.filteredColumns.has("nanodropVolume") && React.createElement(Table.Cell, null, _this.nanodropVolume(pl.params)),
                                _this.state.filteredColumns.has("resuspensionConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params, false)),
                                _this.state.filteredColumns.has("purifiedConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params, false)),
                                _this.state.filteredColumns.has("purifiedVolume") && React.createElement(Table.Cell, null, _this.purifiedVolume(pl.params)),
                                _this.state.filteredColumns.has("finalVolume") && React.createElement(Table.Cell, null, _this.finalVolume(pl.params)),
                                _this.state.filteredColumns.has("targetConcentration") && React.createElement(Table.Cell, null, _this.targetConc(pl.params, false)),
                                _this.state.filteredColumns.has("amountTeAdded") && React.createElement(Table.Cell, null, _this.amountTeAdded(pl.params, false)),
                                _this.state.filteredColumns.has("finalConcentration") && React.createElement(Table.Cell, null, _this.finalConcentration(pl.params, false)),
                                _this.state.filteredColumns.has("yield") && React.createElement(Table.Cell, null, _this.yield(pl.params, false)),
                                _this.state.filteredColumns.has("currentInventory") && React.createElement(Table.Cell, null, _this.currentInventory(pl.params, false)),
                                _this.state.filteredColumns.has("validation") && React.createElement(Table.Cell, null, pl.validation)))) ||
                        // Page Purified probe lots only with collapsed rows
                        ((_this.state.collapseRows && _this.state.showPagePurifiedLots) &&
                            React.createElement("tr", { key: key },
                                React.createElement(Table.Cell, null, _this.editProbeLot(pl, "")),
                                _this.state.filteredColumns.has("status") && React.createElement(Table.Cell, null, pl.params.status),
                                _this.state.filteredColumns.has("organism") && ((pl instanceof CatalogPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CustomPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customOrganismName))),
                                _this.state.filteredColumns.has("geneSymbol") && ((pl instanceof CatalogPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.geneSymbol))
                                    || (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))
                                    || (pl instanceof CustomPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))),
                                _this.state.filteredColumns.has("variant") && ((pl instanceof CatalogPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.variant + '/' + pl.designNumber))
                                    || (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))
                                    || (pl instanceof CustomPagePurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))),
                                _this.state.filteredColumns.has("amplifier") && React.createElement(Table.Cell, null, pl.hcrAmplifier.id),
                                _this.state.filteredColumns.has("probeOrderedDate") && React.createElement(Table.Cell, null, pl.params.orderedDate),
                                _this.state.filteredColumns.has("probeReceivedDate") && React.createElement(Table.Cell, null, pl.params.receivedDate),
                                _this.state.filteredColumns.has("probeSetSize") && (((pl instanceof CatalogPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.probeSetSize))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))
                                    || ((pl instanceof CustomPagePurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))),
                                _this.state.filteredColumns.has("probePurifiedDate") && React.createElement(Table.Cell, null, _this.probePurifiedDate(pl.params)),
                                _this.state.filteredColumns.has("excisedBy") && React.createElement(Table.Cell, null, _this.excisedBy(pl.params)),
                                _this.state.filteredColumns.has("teAddedForResuspension") && React.createElement(Table.Cell, null, _this.resuspension(pl.params)),
                                _this.state.filteredColumns.has("dilutionBeforeQuantification") && React.createElement(Table.Cell, null, _this.dilutionBeforeQuantification(pl.params)),
                                _this.state.filteredColumns.has("dilutionFactorForQuantification") && React.createElement(Table.Cell, null, _this.dilutionFactor(pl.params)),
                                _this.state.filteredColumns.has("coef") && React.createElement(Table.Cell, null, _this.coef(pl.params)),
                                _this.state.filteredColumns.has("a260OfDilutedSample") && React.createElement(Table.Cell, null, _this.a260(pl.params)),
                                _this.state.filteredColumns.has("nanodropVolume") && React.createElement(Table.Cell, null, _this.nanodropVolume(pl.params)),
                                _this.state.filteredColumns.has("resuspensionConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params)),
                                _this.state.filteredColumns.has("purifiedConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params)),
                                _this.state.filteredColumns.has("purifiedVolume") && React.createElement(Table.Cell, null, _this.purifiedVolume(pl.params)),
                                _this.state.filteredColumns.has("finalVolume") && React.createElement(Table.Cell, null, _this.finalVolume(pl.params)),
                                _this.state.filteredColumns.has("targetConcentration") && React.createElement(Table.Cell, null, _this.targetConc(pl.params)),
                                _this.state.filteredColumns.has("amountTeAdded") && React.createElement(Table.Cell, null, _this.amountTeAdded(pl.params)),
                                _this.state.filteredColumns.has("finalConcentration") && React.createElement(Table.Cell, null, _this.finalConcentration(pl.params)),
                                _this.state.filteredColumns.has("yield") && React.createElement(Table.Cell, null, _this.yield(pl.params)),
                                _this.state.filteredColumns.has("currentInventory") && React.createElement(Table.Cell, null, _this.currentInventory(pl.params)),
                                _this.state.filteredColumns.has("validation") && React.createElement(Table.Cell, null, pl.validation))) ||
                        // only shows column purified probe lots
                        ((_this.state.showColumnPurifiedLots) &&
                            React.createElement("tr", { key: key },
                                React.createElement(Table.Cell, null, _this.editProbeLot(pl, "")),
                                _this.state.filteredColumns.has("status") && React.createElement(Table.Cell, null, pl.params.status),
                                _this.state.filteredColumns.has("organism") && ((pl instanceof CatalogColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CustomColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.customOrganismName))),
                                _this.state.filteredColumns.has("geneSymbol") && ((pl instanceof CatalogColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.geneSymbol))
                                    || (pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))
                                    || (pl instanceof CustomColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))),
                                _this.state.filteredColumns.has("variant") && ((pl instanceof CatalogColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.variant + '/' + pl.designNumber))
                                    || (pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))
                                    || (pl instanceof CustomColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))),
                                _this.state.filteredColumns.has("amplifier") && React.createElement(Table.Cell, null, pl.hcrAmplifier.id),
                                _this.state.filteredColumns.has("probeOrderedDate") && React.createElement(Table.Cell, null, pl.params.orderedDate),
                                _this.state.filteredColumns.has("probeReceivedDate") && React.createElement(Table.Cell, null, pl.params.receivedDate),
                                _this.state.filteredColumns.has("probeSetSize") && ((pl instanceof CatalogColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.probeSetSize))
                                    || (pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.customProbeSetSize))
                                    || (pl instanceof CustomColumnPurifiedProbeLot && React.createElement(Table.Cell, null, pl.customProbeSetSize))),
                                _this.state.filteredColumns.has("probePurifiedDate") && React.createElement(Table.Cell, null, _this.probePurifiedDate(pl.params)),
                                _this.state.filteredColumns.has("excisedBy") && React.createElement(Table.Cell, null, _this.excisedBy(pl.params)),
                                _this.state.filteredColumns.has("teAddedForResuspension") && React.createElement(Table.Cell, null, _this.resuspension(pl.params)),
                                _this.state.filteredColumns.has("dilutionBeforeQuantification") && React.createElement(Table.Cell, null, _this.dilutionBeforeQuantification(pl.params)),
                                _this.state.filteredColumns.has("dilutionFactorForQuantification") && React.createElement(Table.Cell, null, _this.dilutionFactor(pl.params)),
                                _this.state.filteredColumns.has("coef") && React.createElement(Table.Cell, null, _this.coef(pl.params)),
                                _this.state.filteredColumns.has("a260OfDilutedSample") && React.createElement(Table.Cell, null, _this.a260(pl.params)),
                                _this.state.filteredColumns.has("nanodropVolume") && React.createElement(Table.Cell, null, _this.nanodropVolume(pl.params)),
                                _this.state.filteredColumns.has("resuspensionConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params)),
                                _this.state.filteredColumns.has("purifiedConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params)),
                                _this.state.filteredColumns.has("purifiedVolume") && React.createElement(Table.Cell, null, _this.purifiedVolume(pl.params)),
                                _this.state.filteredColumns.has("finalVolume") && React.createElement(Table.Cell, null, _this.finalVolume(pl.params)),
                                _this.state.filteredColumns.has("targetConcentration") && React.createElement(Table.Cell, null, _this.targetConc(pl.params)),
                                _this.state.filteredColumns.has("amountTeAdded") && React.createElement(Table.Cell, null, _this.amountTeAdded(pl.params)),
                                _this.state.filteredColumns.has("finalConcentration") && React.createElement(Table.Cell, null, _this.finalConcentration(pl.params)),
                                _this.state.filteredColumns.has("yield") && React.createElement(Table.Cell, null, _this.yield(pl.params)),
                                _this.state.filteredColumns.has("currentInventory") && React.createElement(Table.Cell, null, _this.currentInventory(pl.params)),
                                _this.state.filteredColumns.has("validation") && React.createElement(Table.Cell, null, pl.validation))) ||
                        // Only shows the unpurified probe lots
                        (_this.state.showUnpurifiedLots && (pl instanceof CatalogUnpurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot || pl instanceof CustomUnpurifiedProbeLot) &&
                            React.createElement("tr", { key: key },
                                React.createElement(Table.Cell, null, _this.editProbeLot(pl, "")),
                                _this.state.filteredColumns.has("status") && React.createElement(Table.Cell, null, pl.params.status),
                                _this.state.filteredColumns.has("organism") && ((pl instanceof CatalogUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.organism))
                                    || (pl instanceof CustomUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.customOrganismName))),
                                _this.state.filteredColumns.has("geneSymbol") && ((pl instanceof CatalogUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.geneSymbol))
                                    || (pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))
                                    || (pl instanceof CustomUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.customGeneSymbolName))),
                                _this.state.filteredColumns.has("variant") && ((pl instanceof CatalogUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.variant + '/' + pl.designNumber))
                                    || (pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))
                                    || (pl instanceof CustomUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.customVariantName))),
                                _this.state.filteredColumns.has("amplifier") && React.createElement(Table.Cell, null, pl.hcrAmplifier.id),
                                _this.state.filteredColumns.has("probeOrderedDate") && React.createElement(Table.Cell, null, pl.params.orderedDate),
                                _this.state.filteredColumns.has("probeReceivedDate") && React.createElement(Table.Cell, null, pl.params.receivedDate),
                                _this.state.filteredColumns.has("probeSetSize") && ((pl instanceof CatalogUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.probeSetSize))
                                    || (pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.customProbeSetSize))
                                    || (pl instanceof CustomUnpurifiedProbeLot && React.createElement(Table.Cell, null, pl.customProbeSetSize))),
                                _this.state.filteredColumns.has("probePurifiedDate") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("excisedBy") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("teAddedForResuspension") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("dilutionBeforeQuantification") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("dilutionFactorForQuantification") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("coef") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("a260OfDilutedSample") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("nanodropVolume") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("resuspensionConcentration") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("purifiedConcentration") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("purifiedVolume") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("finalVolume") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("targetConcentration") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("amountTeAdded") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("finalConcentration") && React.createElement(Table.Cell, null, "N/A"),
                                _this.state.filteredColumns.has("yield") && React.createElement(Table.Cell, null, pl.params.lotYield ? pl.params.lotYield : 'No Yield'),
                                _this.state.filteredColumns.has("currentInventory") && React.createElement(Table.Cell, null, pl.params.currentInventory ? pl.params.currentInventory : 'No Inventory'),
                                _this.state.filteredColumns.has("validation") && React.createElement(Table.Cell, null, pl.validation))) ||
                        // shows all the probe lots collapsed
                        ((!_this.state.showPagePurifiedLots && !_this.state.showUnpurifiedLots && !_this.state.showColumnPurifiedLots) &&
                            React.createElement("tr", { key: key },
                                React.createElement(Table.Cell, null, _this.editProbeLot(pl, "")),
                                _this.state.filteredColumns.has("status") && React.createElement(Table.Cell, null, pl.params.status),
                                _this.state.filteredColumns.has("organism") && (((pl instanceof CatalogPagePurifiedProbeLot || pl instanceof CatalogColumnPurifiedProbeLot || pl instanceof CatalogUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.organism))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.organism))
                                    || ((pl instanceof CustomPagePurifiedProbeLot || pl instanceof CustomColumnPurifiedProbeLot || pl instanceof CustomUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customOrganismName))),
                                _this.state.filteredColumns.has("geneSymbol") && (((pl instanceof CatalogPagePurifiedProbeLot || pl instanceof CatalogColumnPurifiedProbeLot || pl instanceof CatalogUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.geneSymbol))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customGeneSymbolName))
                                    || ((pl instanceof CustomPagePurifiedProbeLot || pl instanceof CustomColumnPurifiedProbeLot || pl instanceof CustomUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customGeneSymbolName))),
                                _this.state.filteredColumns.has("variant") && (((pl instanceof CatalogPagePurifiedProbeLot || pl instanceof CatalogColumnPurifiedProbeLot || pl instanceof CatalogUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.variant + '/' + pl.designNumber))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customVariantName))
                                    || ((pl instanceof CustomPagePurifiedProbeLot || pl instanceof CustomColumnPurifiedProbeLot || pl instanceof CustomUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customVariantName))),
                                _this.state.filteredColumns.has("amplifier") && React.createElement(Table.Cell, null, pl.hcrAmplifier.id),
                                _this.state.filteredColumns.has("probeOrderedDate") && React.createElement(Table.Cell, null, pl.params.orderedDate),
                                _this.state.filteredColumns.has("probeReceivedDate") && React.createElement(Table.Cell, null, pl.params.receivedDate),
                                _this.state.filteredColumns.has("probeSetSize") && (((pl instanceof CatalogPagePurifiedProbeLot || pl instanceof CatalogColumnPurifiedProbeLot || pl instanceof CatalogUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.probeSetSize))
                                    || ((pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))
                                    || ((pl instanceof CustomPagePurifiedProbeLot || pl instanceof CustomColumnPurifiedProbeLot || pl instanceof CustomUnpurifiedProbeLot) && React.createElement(Table.Cell, null, pl.customProbeSetSize))),
                                _this.state.filteredColumns.has("probePurifiedDate") && React.createElement(Table.Cell, null, _this.probePurifiedDate(pl.params)),
                                _this.state.filteredColumns.has("excisedBy") && React.createElement(Table.Cell, null, _this.excisedBy(pl.params)),
                                _this.state.filteredColumns.has("teAddedForResuspension") && React.createElement(Table.Cell, null, _this.resuspension(pl.params)),
                                _this.state.filteredColumns.has("dilutionBeforeQuantification") && React.createElement(Table.Cell, null, _this.dilutionBeforeQuantification(pl.params)),
                                _this.state.filteredColumns.has("dilutionFactorForQuantification") && React.createElement(Table.Cell, null, _this.dilutionFactor(pl.params)),
                                _this.state.filteredColumns.has("coef") && React.createElement(Table.Cell, null, _this.coef(pl.params)),
                                _this.state.filteredColumns.has("a260OfDilutedSample") && React.createElement(Table.Cell, null, _this.a260(pl.params)),
                                _this.state.filteredColumns.has("nanodropVolume") && React.createElement(Table.Cell, null, _this.nanodropVolume(pl.params)),
                                _this.state.filteredColumns.has("resuspensionConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params)),
                                _this.state.filteredColumns.has("purifiedConcentration") && React.createElement(Table.Cell, null, _this.actualConcentration(pl.params)),
                                _this.state.filteredColumns.has("purifiedVolume") && React.createElement(Table.Cell, null, _this.purifiedVolume(pl.params)),
                                _this.state.filteredColumns.has("finalVolume") && React.createElement(Table.Cell, null, _this.finalVolume(pl.params)),
                                _this.state.filteredColumns.has("targetConcentration") && React.createElement(Table.Cell, null, _this.targetConc(pl.params)),
                                _this.state.filteredColumns.has("amountTeAdded") && React.createElement(Table.Cell, null, _this.amountTeAdded(pl.params)),
                                _this.state.filteredColumns.has("finalConcentration") && React.createElement(Table.Cell, null, _this.finalConcentration(pl.params)),
                                _this.state.filteredColumns.has("yield") && React.createElement(Table.Cell, null, _this.yield(pl.params)),
                                _this.state.filteredColumns.has("currentInventory") && React.createElement(Table.Cell, null, _this.currentInventory(pl.params)),
                                _this.state.filteredColumns.has("validation") && React.createElement(Table.Cell, null, pl.validation)));
                })));
        };
        _this.onPageChange = function (_, data) {
            var path = "/rna/probe-lots?pageNumber=" + encodeURIComponent(data.activePage - 1);
            if (_this.state.reorderFilter) {
                path = path + "&reorderFilter=true";
            }
            if (_this.state.showPagePurifiedLots) {
                path = path + ("&probeLotType=" + ProbeLotTypeFilter.PAGE_PURIFIED);
            }
            else if (_this.state.showUnpurifiedLots) {
                path = path + ("&probeLotType=" + ProbeLotTypeFilter.UNPURIFIED);
            }
            else if (_this.state.showColumnPurifiedLots) {
                path = path + ("&probeLotType=" + ProbeLotTypeFilter.COLUMN_PURIFIED);
            }
            if (_this.state.orgFilter !== "") {
                path = path + ("&organism=" + encodeURIComponent(_this.state.orgFilter));
            }
            if (_this.state.geneSymbolFilter !== "") {
                path = path + ("&geneSymbol=" + encodeURIComponent(_this.state.geneSymbolFilter));
            }
            if (_this.state.probeLotFilter !== "") {
                path = path + ("&probeLotFilter=" + encodeURIComponent(_this.state.probeLotFilter));
            }
            if (_this.state.designNumberFilter !== "") {
                path = path + ("&designNumber=" + encodeURIComponent(_this.state.designNumberFilter));
            }
            if (_this) {
                _this.setState({
                    loading: true
                }, function () {
                    getWithAuthn(path)
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (resp) {
                        if (resp === undefined) {
                            _this.setState({
                                loading: false,
                                error: true
                            });
                        }
                        else {
                            _this.setState({
                                loading: false,
                                totalPages: resp.probeLots.totalPages,
                                currentPage: data.activePage,
                                probeLots: _this.deserializeProbeLots(resp.probeLots.probeLots)
                            });
                        }
                    })
                        .catch(function (rej) {
                        console.error("Couldn't load probe lots: " + rej);
                    });
                });
            }
        };
        _this.oddOrEven = function (params, a, b) {
            if (params.currentOddInventory == null || params.currentEvenInventory == null) {
                return a;
            }
            else if (params.currentOddInventory <= params.currentEvenInventory) {
                return a;
            }
            else {
                return b;
            }
        };
        _this.editProbeLot = function (probeLot, evenOrOdd) {
            var evenOrOddLabel = '';
            if (probeLot instanceof CatalogPagePurifiedProbeLot || probeLot instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot ||
                probeLot instanceof CustomPagePurifiedProbeLot) {
                evenOrOddLabel = evenOrOdd;
            }
            var renderEditProbeLot = function (props) {
                if (probeLot instanceof CatalogPagePurifiedProbeLot || probeLot instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot ||
                    probeLot instanceof CustomPagePurifiedProbeLot) {
                    return React.createElement(EditPagePurifiedProbeLotModal, __assign({ probeLot: probeLot, variantName: probeLot instanceof CatalogPagePurifiedProbeLot ? probeLot.variant : probeLot.customVariantName, suppliers: _this.state.suppliers }, props));
                }
                else if (probeLot instanceof CatalogColumnPurifiedProbeLot || probeLot instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot ||
                    probeLot instanceof CustomColumnPurifiedProbeLot) {
                    return React.createElement(EditColumnPurifiedProbeLotModal, __assign({ probeLot: probeLot, suppliers: _this.state.suppliers }, props));
                }
                else {
                    return React.createElement(EditUnpurifiedProbeLotModal, __assign({ probeLot: probeLot, suppliers: _this.state.suppliers }, props));
                }
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentProbeLotPage, trigger: React.createElement(Button, { icon: 'edit', labelPosition: 'left', label: probeLot.lotNumber + ' ' + evenOrOddLabel }) },
                React.createElement(Modal.Header, null, "Edit Probe Lot"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEditProbeLot, successMessage: 'Probe Lot Edited' })));
        };
        _this.createAndDownloadOrderForms = function () {
            _this.setState({ creatingOrderForms: true }, function () {
                getWithAuthn('/rna/probe-lot/create-and-download-lots-order-form')
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            creatingOrderForms: false,
                            orderFormSummary: { results: [], errors: ['Failed to create order forms.'] }
                        });
                        return;
                    }
                    // The zip comes back base64-encoded inside the JSON (alongside results/errors), so we decode it
                    // and trigger the download client-side rather than navigating the browser to the endpoint.
                    if (resp.zipBase64) {
                        _this.triggerZipDownload(resp.zipBase64, resp.zipFilename);
                    }
                    _this.setState({
                        creatingOrderForms: false,
                        orderFormSummary: { results: resp.results, errors: resp.errors }
                    });
                })
                    .catch(function (rej) {
                    console.error("Couldn't create order forms: " + rej);
                    _this.setState({
                        creatingOrderForms: false,
                        orderFormSummary: { results: [], errors: ["Couldn't create order forms: " + rej] }
                    });
                });
            });
        };
        _this.triggerZipDownload = function (zipBase64, filename) {
            var binary = atob(zipBase64);
            var bytes = new Uint8Array(binary.length);
            for (var i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            downloadBlob(filename, bytes, 'application/zip');
        };
        _this.loadCurrentProbeLotPage = function () {
            var path = "/rna/probe-lots?pageNumber=" + encodeURIComponent(_this.state.currentPage - 1);
            if (_this.state.reorderFilter) {
                path = path + "&reorderFilter=true";
            }
            if (_this.state.showPagePurifiedLots) {
                path = path + ("&probeLotType=" + ProbeLotTypeFilter.PAGE_PURIFIED);
            }
            else if (_this.state.showUnpurifiedLots) {
                path = path + ("&probeLotType=" + ProbeLotTypeFilter.UNPURIFIED);
            }
            else if (_this.state.showColumnPurifiedLots) {
                path = path + ("&probeLotType=" + ProbeLotTypeFilter.COLUMN_PURIFIED);
            }
            if (_this.state.orgFilter !== "") {
                path = path + ("&organism=" + encodeURIComponent(_this.state.orgFilter));
            }
            if (_this.state.geneSymbolFilter !== "") {
                path = path + ("&geneSymbol=" + encodeURIComponent(_this.state.geneSymbolFilter));
            }
            if (_this.state.probeLotFilter !== "") {
                path = path + ("&probeLotFilter=" + encodeURIComponent(_this.state.probeLotFilter));
            }
            if (_this.state.designNumberFilter !== "") {
                path = path + ("&designNumber=" + encodeURIComponent(_this.state.designNumberFilter));
            }
            if (_this) {
                _this.setState({
                    loading: true
                }, function () {
                    getWithAuthn(path)
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (resp) {
                        if (resp === undefined) {
                            _this.setState({
                                loading: false,
                                error: true
                            });
                        }
                        else {
                            _this.setState({
                                loading: false,
                                totalPages: resp.probeLots.totalPages,
                                probeLots: _this.deserializeProbeLots(resp.probeLots.probeLots),
                                suppliers: resp.suppliers
                            });
                        }
                    })
                        .catch(function (rej) {
                        console.error("Couldn't load probe lots: " + rej);
                    });
                });
            }
        };
        _this.deserializeProbeLots = function (probeLots) {
            return probeLots.map(function (pl) {
                switch (pl._type) {
                    case 'CatalogPagePurifiedProbeLot':
                        var catalogPurifiedSplitPl = pl;
                        return new CatalogPagePurifiedProbeLot(catalogPurifiedSplitPl._type, catalogPurifiedSplitPl.id, catalogPurifiedSplitPl.lotNumber, catalogPurifiedSplitPl.deactivated, catalogPurifiedSplitPl.reasonForDeactivation, catalogPurifiedSplitPl.hcrAmplifier, catalogPurifiedSplitPl.validation, catalogPurifiedSplitPl.organism, catalogPurifiedSplitPl.geneSymbol, catalogPurifiedSplitPl.variant, catalogPurifiedSplitPl.designNumber, catalogPurifiedSplitPl.accession, catalogPurifiedSplitPl.sequence, catalogPurifiedSplitPl.probeSetSize, new PagePurifiedProbeLotParams(catalogPurifiedSplitPl.params));
                    case 'CatalogOrganismCustomTargetPagePurifiedProbeLot':
                        var catalogOrgCustomTargetPurifiedSplitPl = pl;
                        return new CatalogOrganismCustomTargetPagePurifiedProbeLot(catalogOrgCustomTargetPurifiedSplitPl._type, catalogOrgCustomTargetPurifiedSplitPl.id, catalogOrgCustomTargetPurifiedSplitPl.lotNumber, catalogOrgCustomTargetPurifiedSplitPl.deactivated, catalogOrgCustomTargetPurifiedSplitPl.reasonForDeactivation, catalogOrgCustomTargetPurifiedSplitPl.hcrAmplifier, catalogOrgCustomTargetPurifiedSplitPl.validation, catalogOrgCustomTargetPurifiedSplitPl.organism, catalogOrgCustomTargetPurifiedSplitPl.customGeneSymbolName, catalogOrgCustomTargetPurifiedSplitPl.customVariantName, catalogOrgCustomTargetPurifiedSplitPl.customAccession, catalogOrgCustomTargetPurifiedSplitPl.customSequence, catalogOrgCustomTargetPurifiedSplitPl.customProbeSetSize, new PagePurifiedProbeLotParams(catalogOrgCustomTargetPurifiedSplitPl.params));
                    case 'CustomPagePurifiedProbeLot':
                        var customPurifiedSplitPl = pl;
                        return new CustomPagePurifiedProbeLot(customPurifiedSplitPl._type, customPurifiedSplitPl.id, customPurifiedSplitPl.lotNumber, customPurifiedSplitPl.deactivated, customPurifiedSplitPl.reasonForDeactivation, customPurifiedSplitPl.hcrAmplifier, customPurifiedSplitPl.validation, customPurifiedSplitPl.customOrganismName, customPurifiedSplitPl.customGeneSymbolName, customPurifiedSplitPl.customVariantName, customPurifiedSplitPl.customAccession, customPurifiedSplitPl.customSequence, customPurifiedSplitPl.customProbeSetSize, new PagePurifiedProbeLotParams(customPurifiedSplitPl.params));
                    case 'CatalogColumnPurifiedProbeLot':
                        var catalogPurifiedMergedPl = pl;
                        return new CatalogColumnPurifiedProbeLot(catalogPurifiedMergedPl._type, catalogPurifiedMergedPl.id, catalogPurifiedMergedPl.lotNumber, catalogPurifiedMergedPl.deactivated, catalogPurifiedMergedPl.reasonForDeactivation, catalogPurifiedMergedPl.hcrAmplifier, catalogPurifiedMergedPl.validation, catalogPurifiedMergedPl.organism, catalogPurifiedMergedPl.geneSymbol, catalogPurifiedMergedPl.variant, catalogPurifiedMergedPl.designNumber, catalogPurifiedMergedPl.accession, catalogPurifiedMergedPl.sequence, catalogPurifiedMergedPl.probeSetSize, new ColumnPurifiedProbeLotParams(catalogPurifiedMergedPl.params));
                    case 'CatalogOrganismCustomTargetColumnPurifiedProbeLot':
                        var catalogOrgCustomTargetPurifiedMergedPl = pl;
                        return new CatalogOrganismCustomTargetColumnPurifiedProbeLot(catalogOrgCustomTargetPurifiedMergedPl._type, catalogOrgCustomTargetPurifiedMergedPl.id, catalogOrgCustomTargetPurifiedMergedPl.lotNumber, catalogOrgCustomTargetPurifiedMergedPl.deactivated, catalogOrgCustomTargetPurifiedMergedPl.reasonForDeactivation, catalogOrgCustomTargetPurifiedMergedPl.hcrAmplifier, catalogOrgCustomTargetPurifiedMergedPl.validation, catalogOrgCustomTargetPurifiedMergedPl.organism, catalogOrgCustomTargetPurifiedMergedPl.customGeneSymbolName, catalogOrgCustomTargetPurifiedMergedPl.customVariantName, catalogOrgCustomTargetPurifiedMergedPl.customAccession, catalogOrgCustomTargetPurifiedMergedPl.customSequence, catalogOrgCustomTargetPurifiedMergedPl.customProbeSetSize, new ColumnPurifiedProbeLotParams(catalogOrgCustomTargetPurifiedMergedPl.params));
                    case 'CustomColumnPurifiedProbeLot':
                        var customPurifiedMergedPl = pl;
                        return new CustomColumnPurifiedProbeLot(customPurifiedMergedPl._type, customPurifiedMergedPl.id, customPurifiedMergedPl.lotNumber, customPurifiedMergedPl.deactivated, customPurifiedMergedPl.reasonForDeactivation, customPurifiedMergedPl.hcrAmplifier, customPurifiedMergedPl.validation, customPurifiedMergedPl.customOrganismName, customPurifiedMergedPl.customGeneSymbolName, customPurifiedMergedPl.customVariantName, customPurifiedMergedPl.customAccession, customPurifiedMergedPl.customSequence, customPurifiedMergedPl.customProbeSetSize, new ColumnPurifiedProbeLotParams(customPurifiedMergedPl.params));
                    case 'CatalogUnpurifiedProbeLot':
                        var catalogUnpurifiedPl = pl;
                        return new CatalogUnpurifiedProbeLot(catalogUnpurifiedPl._type, catalogUnpurifiedPl.id, catalogUnpurifiedPl.lotNumber, catalogUnpurifiedPl.deactivated, catalogUnpurifiedPl.reasonForDeactivation, catalogUnpurifiedPl.hcrAmplifier, catalogUnpurifiedPl.validation, catalogUnpurifiedPl.organism, catalogUnpurifiedPl.geneSymbol, catalogUnpurifiedPl.variant, catalogUnpurifiedPl.designNumber, catalogUnpurifiedPl.accession, catalogUnpurifiedPl.sequence, catalogUnpurifiedPl.probeSetSize, new UnpurifiedProbeLotParams(catalogUnpurifiedPl.params));
                    case 'CatalogOrganismCustomTargetUnpurifiedProbeLot':
                        var catalogOrgCustomTargetUnpurifiedPl = pl;
                        return new CatalogOrganismCustomTargetUnpurifiedProbeLot(catalogOrgCustomTargetUnpurifiedPl._type, catalogOrgCustomTargetUnpurifiedPl.id, catalogOrgCustomTargetUnpurifiedPl.lotNumber, catalogOrgCustomTargetUnpurifiedPl.deactivated, catalogOrgCustomTargetUnpurifiedPl.reasonForDeactivation, catalogOrgCustomTargetUnpurifiedPl.hcrAmplifier, catalogOrgCustomTargetUnpurifiedPl.validation, catalogOrgCustomTargetUnpurifiedPl.organism, catalogOrgCustomTargetUnpurifiedPl.customGeneSymbolName, catalogOrgCustomTargetUnpurifiedPl.customVariantName, catalogOrgCustomTargetUnpurifiedPl.customAccession, catalogOrgCustomTargetUnpurifiedPl.customSequence, catalogOrgCustomTargetUnpurifiedPl.customProbeSetSize, new UnpurifiedProbeLotParams(catalogOrgCustomTargetUnpurifiedPl.params));
                    case 'CustomUnpurifiedProbeLot':
                        var customUnpurifiedPl = pl;
                        return new CustomUnpurifiedProbeLot(customUnpurifiedPl._type, customUnpurifiedPl.id, customUnpurifiedPl.lotNumber, customUnpurifiedPl.deactivated, customUnpurifiedPl.reasonForDeactivation, customUnpurifiedPl.hcrAmplifier, customUnpurifiedPl.validation, customUnpurifiedPl.customOrganismName, customUnpurifiedPl.customGeneSymbolName, customUnpurifiedPl.customVariantName, customUnpurifiedPl.customAccession, customUnpurifiedPl.customSequence, customUnpurifiedPl.customProbeSetSize, new UnpurifiedProbeLotParams(customUnpurifiedPl.params));
                    default:
                        throw new Error("Unknown type: " + pl._type);
                }
            });
        };
        _this.excisedBy = function (params, odd) {
            if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddExcisedPrecipitatedQuantifiedBy;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenExcisedPrecipitatedQuantifiedBy;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddExcisedPrecipitatedQuantifiedBy, params.evenExcisedPrecipitatedQuantifiedBy);
            }
            else {
                return 'N/A';
            }
        };
        _this.resuspension = function (params, odd) {
            if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddResuspension;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenResuspension;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddResuspension, params.evenResuspension);
            }
            else {
                return 'N/A';
            }
        };
        _this.nanodropVolume = function (_) {
            return 'N/A';
        };
        _this.purifiedVolume = function (params) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.purifiedVolume;
            }
            else {
                return 'N/A';
            }
        };
        _this.finalVolume = function (params) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.finalVolume;
            }
            else {
                return 'N/A';
            }
        };
        _this.dilutionBeforeQuantification = function (params, odd) {
            if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddDilutionBeforeQuantification;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenDilutionBeforeQuantification;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddDilutionBeforeQuantification, params.evenDilutionBeforeQuantification);
            }
            else {
                return 'N/A';
            }
        };
        _this.dilutionFactor = function (params, odd) {
            if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddDilutionFactorForQuantification;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenDilutionFactorForQuantification;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddDilutionFactorForQuantification, params.evenDilutionFactorForQuantification);
            }
            else {
                return 'N/A';
            }
        };
        _this.a260 = function (params, odd) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.a260OfDilutedSample;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddA260OfDilutedSample;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenA260OfDilutedSample;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddA260OfDilutedSample, params.evenA260OfDilutedSample);
            }
            else {
                return 'N/A';
            }
        };
        _this.coef = function (params, odd) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.coef;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddCoef;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenCoef;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddCoef, params.evenCoef);
            }
            else {
                return 'N/A';
            }
        };
        _this.actualConcentration = function (params, odd) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.actualConcentration;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddResuspensionConcentration;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenResuspensionConcentration;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddResuspensionConcentration, params.evenResuspensionConcentration);
            }
            else {
                return 'N/A';
            }
        };
        _this.targetConc = function (params, odd) {
            if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddTargetConcentration;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenTargetConcentration;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddTargetConcentration, params.evenTargetConcentration);
            }
            else {
                return 'N/A';
            }
        };
        _this.amountTeAdded = function (params, odd) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.amountTeAdded;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddAmountTeAdded;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenAmountTeAdded;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddAmountTeAdded, params.evenAmountTeAdded);
            }
            else {
                return 'N/A';
            }
        };
        _this.finalConcentration = function (params, odd) {
            if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.oddFinalConcentration;
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.evenFinalConcentration;
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return _this.oddOrEven(params, params.oddFinalConcentration, params.evenFinalConcentration);
            }
            else {
                return 'N/A';
            }
        };
        _this.yield = function (params, odd) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.checkInventory ? "Check Inventory" : params.lotYield ? params.lotYield : "Calculate Yield";
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.checkInventory ? "Check Inventory" : params.oddLotYield ? params.oddLotYield : "Calculate Yield";
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.checkInventory ? "Check Inventory" : params.evenLotYield ? params.evenLotYield : "Calculate Yield";
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return params.checkInventory ? "Check Inventory" : _this.oddOrEven(params, params.oddLotYield, params.evenLotYield) ? _this.oddOrEven(params, params.oddLotYield, params.evenLotYield) : "Calculate Yield";
            }
            else {
                return params.lotYield ? params.lotYield : "Input Yield";
            }
        };
        _this.currentInventory = function (params, odd) {
            if (params instanceof ColumnPurifiedProbeLotParams) {
                return params.checkInventory ? "Check Inventory" : params.lotYield ? params.currentInventory : "Calculate Yield";
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === true) {
                return params.checkInventory ? "Check Inventory" : params.currentOddInventory ? params.currentOddInventory : "Calculate Yield";
            }
            else if (params instanceof PagePurifiedProbeLotParams && odd === false) {
                return params.checkInventory ? "Check Inventory" : params.currentEvenInventory ? params.currentEvenInventory : "Calculate Yield";
            }
            else if (params instanceof PagePurifiedProbeLotParams) {
                return params.checkInventory ? "Check Inventory" : _this.oddOrEven(params, params.currentOddInventory, params.currentEvenInventory) ? _this.oddOrEven(params, params.currentOddInventory, params.currentEvenInventory) : "Calculate Yield";
            }
            else {
                return params.lotYield ? params.currentInventory : "Input Yield";
            }
        };
        _this.probePurifiedDate = function (params) {
            if (params instanceof ColumnPurifiedProbeLotParams || params instanceof PagePurifiedProbeLotParams) {
                return params.purifiedDate;
            }
            else {
                return 'N/A';
            }
        };
        _this.state = {
            probeLots: [],
            reorderFilter: false,
            loading: false,
            error: false,
            orgFilter: '',
            geneSymbolFilter: '',
            probeLotFilter: '',
            designNumberFilter: '',
            showPagePurifiedLots: false,
            showColumnPurifiedLots: false,
            showUnpurifiedLots: false,
            collapseRows: true,
            showPagePurifiedOptimizationRows: false,
            showColumnPurifiedOptimizationRows: false,
            filteredColumns: new Set([
                "organism",
                "geneSymbol",
                "variant",
                "amplifier",
                "probeSetSize",
                "yield",
                "currentInventory",
                "validation"
            ]),
            currentPage: 1,
            totalPages: 0,
            suppliers: [],
            creatingOrderForms: false
        };
        return _this;
    }
    ProbeLotTablePage.prototype.componentDidMount = function () {
        this.loadCurrentProbeLotPage();
    };
    ProbeLotTablePage.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Probe lots could not be loaded."),
                this.state.orderFormSummary !== undefined &&
                    React.createElement(Modal, { open: true, closeIcon: true, onClose: function () { return _this.setState({ orderFormSummary: undefined }); } },
                        React.createElement(Modal.Header, null, "Create lots and download order forms"),
                        React.createElement(Modal.Content, { scrolling: true },
                            this.state.orderFormSummary.errors.length > 0 &&
                                React.createElement(Message, { negative: true },
                                    React.createElement(Message.Header, null,
                                        "Errors (",
                                        this.state.orderFormSummary.errors.length,
                                        ")"),
                                    React.createElement(Message.List, { items: this.state.orderFormSummary.errors })),
                            this.state.orderFormSummary.results.length > 0 &&
                                React.createElement(Message, { positive: true },
                                    React.createElement(Message.Header, null,
                                        "Results (",
                                        this.state.orderFormSummary.results.length,
                                        ")"),
                                    React.createElement(Message.List, { items: this.state.orderFormSummary.results })),
                            this.state.orderFormSummary.results.length === 0 && this.state.orderFormSummary.errors.length === 0 &&
                                React.createElement("p", null, "No lots were processed.")),
                        React.createElement(Modal.Actions, null,
                            React.createElement(Button, { onClick: function () { return _this.setState({ orderFormSummary: undefined }); } }, "Close"))),
                React.createElement(Menu, { className: 'menu-container' },
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { onChange: debounce(this.onProbeLotFilterChange, 300), placeholder: 'PRA 257' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { onChange: debounce(this.onOrganismFilterChange, 300), placeholder: 'Chupacabra' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { onChange: debounce(this.onGeneSymbolFilterChange, 300), type: 'text', placeholder: 'Filter Probe Set Family' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { onChange: debounce(this.onDesignNumberFilterChange, 300), type: 'text', placeholder: 'Filter Design Number' }))),
                React.createElement(Menu, { className: 'menu-container' },
                    React.createElement(Menu.Item, null,
                        React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Initial), render: this.createNewPagePurifiedProbeLot })),
                    React.createElement(Menu.Item, null,
                        React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Initial), render: this.createNewColumnPurifiedProbeLot })),
                    React.createElement(Menu.Item, null,
                        React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Initial), render: this.createNewUnpurifiedProbeLot })),
                    React.createElement(Menu.Item, null, this.uploadReceivedProbeLots()),
                    React.createElement(Menu.Item, null, this.uploadPurifiedProbeLots())),
                React.createElement(Menu, { className: 'menu-container' },
                    React.createElement(Menu.Item, null,
                        React.createElement(Button, { icon: 'download', label: 'Create lots and download order forms', labelPosition: 'left', loading: this.state.creatingOrderForms, disabled: this.state.creatingOrderForms, onClick: this.createAndDownloadOrderForms })),
                    React.createElement(Menu.Item, null, this.uploadOrderedProbeLots())),
                React.createElement(Menu, { className: 'menu-container' },
                    React.createElement(Menu.Item, null,
                        React.createElement(Checkbox, { checked: this.state.reorderFilter, label: "Show Empty Probe Lots", onChange: this.onReorderChange })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Checkbox, { checked: this.state.showPagePurifiedLots, label: "Show Only HigherFi Probe Lots", onChange: this.onShowPagePurifiedOnlyChange })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Checkbox, { checked: this.state.showColumnPurifiedLots, label: "Show Only HiFi Probe Lots", onChange: this.onShowColumnPurifiedOnlyChange })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Checkbox, { checked: this.state.showUnpurifiedLots, label: "Show Only v3.0 Probe Lots", onChange: this.onShowUnpurifiedOnlyChange }))),
                React.createElement(Menu, { className: 'menu-container' },
                    this.state.showPagePurifiedLots && React.createElement(Menu.Item, null,
                        React.createElement(Checkbox, { checked: this.state.collapseRows, label: "Collapse Rows", onChange: this.onCollapseRowsChange })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Checkbox, { checked: this.state.showPagePurifiedOptimizationRows, label: "Show HigherFi Optimization Info", onChange: this.onShowPagePurifiedOptimizationRows })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Checkbox, { checked: this.state.showColumnPurifiedOptimizationRows, label: "Show HiFi Optimization Info", onChange: this.onShowColumnPurifiedOptimizationRows })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Popup, { on: 'click', trigger: React.createElement(Button, { icon: 'check square outline', label: 'Filter Columns', labelPosition: 'left' }), flowing: true }, this.renderColumnToggles(["status",
                            "organism",
                            "geneSymbol",
                            "variant",
                            "amplifier",
                            "probeOrderedDate",
                            "probeReceivedDate",
                            "probeSetSize",
                            "probePurifiedDate",
                            "excisedBy",
                            "teAddedForResuspension",
                            "nanodropVolume",
                            "purifiedVolume",
                            "finalVolume",
                            "dilutionBeforeQuantification",
                            "dilutionFactorForQuantification",
                            "a260OfDilutedSample",
                            "coef",
                            "resuspensionConcentration",
                            "purifiedConcentration",
                            "targetConcentration",
                            "amountTeAdded",
                            "finalConcentration",
                            "yield",
                            "currentInventory",
                            "validation"
                        ])))),
                React.createElement(Menu, { className: 'menu-container' },
                    React.createElement(Menu.Item, null,
                        React.createElement(Pagination, { totalPages: this.state.totalPages, ellipsisItem: null, onPageChange: this.onPageChange, activePage: this.state.currentPage }))),
                this.state.probeLots &&
                    React.createElement("div", { className: "probeLots" }, this.renderProbeLots())));
    };
    return ProbeLotTablePage;
}(React.PureComponent));
export default ProbeLotTablePage;
var pagePurifiedRows = ["teAddedForResuspension", "a260OfDilutedSample", "resuspensionConcentration", "targetConcentration", "amountTeAdded"];
var columnPurifiedRows = ["finalVolume", "purifiedVolume", "a260OfDilutedSample", "purifiedConcentration", "amountTeAdded"];
var PagePurifiedProbeLotParams = /** @class */ (function () {
    function PagePurifiedProbeLotParams(p) {
        this.status = p.status;
        this.checkInventory = p.checkInventory;
        this.probeSetSize = p.probeSetSize;
        this.poNumber = p.poNumber;
        this.supplier = p.supplier;
        this.oddExcisedPrecipitatedQuantifiedBy = p.oddExcisedPrecipitatedQuantifiedBy;
        this.oddResuspension = p.oddResuspension;
        this.oddDilutionBeforeQuantification = p.oddDilutionBeforeQuantification;
        this.oddDilutionFactorForQuantification = p.oddDilutionFactorForQuantification;
        this.oddA260OfDilutedSample = p.oddA260OfDilutedSample;
        this.oddCoef = p.oddCoef;
        this.oddResuspensionConcentration = p.oddResuspensionConcentration;
        this.oddTargetConcentration = p.oddTargetConcentration;
        this.oddAmountTeAdded = p.oddAmountTeAdded;
        this.oddYieldPercentage = p.oddYieldPercentage;
        this.oddYieldPerOligo = p.oddYieldPerOligo;
        this.oddFinalConcentration = p.oddFinalConcentration;
        this.evenExcisedPrecipitatedQuantifiedBy = p.evenExcisedPrecipitatedQuantifiedBy;
        this.evenResuspension = p.evenResuspension;
        this.evenDilutionBeforeQuantification = p.evenDilutionBeforeQuantification;
        this.evenDilutionFactorForQuantification = p.evenDilutionFactorForQuantification;
        this.evenA260OfDilutedSample = p.evenA260OfDilutedSample;
        this.evenCoef = p.evenCoef;
        this.evenResuspensionConcentration = p.evenResuspensionConcentration;
        this.evenTargetConcentration = p.evenTargetConcentration;
        this.evenAmountTeAdded = p.evenAmountTeAdded;
        this.evenFinalConcentration = p.evenFinalConcentration;
        this.oddLotYield = p.oddLotYield;
        this.evenLotYield = p.evenLotYield;
        this.currentOddInventory = p.currentOddInventory;
        this.currentEvenInventory = p.currentEvenInventory;
        this.createdDate = p.createdDate;
        this.orderedDate = p.orderedDate;
        this.receivedDate = p.receivedDate;
        this.purifiedDate = p.purifiedDate;
    }
    return PagePurifiedProbeLotParams;
}());
export { PagePurifiedProbeLotParams };
var ColumnPurifiedProbeLotParams = /** @class */ (function () {
    function ColumnPurifiedProbeLotParams(p) {
        this.status = p.status;
        this.checkInventory = p.checkInventory;
        this.probeSetSize = p.probeSetSize;
        this.poNumber = p.poNumber;
        this.supplier = p.supplier;
        this.purifiedBy = p.purifiedBy;
        this.targetConcentration = p.targetConcentration;
        this.purifiedVolume = p.purifiedVolume;
        this.a260OfDilutedSample = p.a260OfDilutedSample;
        this.coef = p.coef;
        this.actualConcentration = p.actualConcentration;
        this.finalVolume = p.finalVolume;
        this.amountTeAdded = p.amountTeAdded;
        this.lotYield = p.lotYield;
        this.currentInventory = p.currentInventory;
        this.createdDate = p.createdDate;
        this.orderedDate = p.orderedDate;
        this.receivedDate = p.receivedDate;
        this.purifiedDate = p.purifiedDate;
    }
    return ColumnPurifiedProbeLotParams;
}());
export { ColumnPurifiedProbeLotParams };
var UnpurifiedProbeLotParams = /** @class */ (function () {
    function UnpurifiedProbeLotParams(p) {
        this.status = p.status;
        this.poNumber = p.poNumber;
        this.supplier = p.supplier;
        this.lotYield = p.lotYield;
        this.currentInventory = p.currentInventory;
        this.createdDate = p.createdDate;
        this.orderedDate = p.orderedDate;
        this.receivedDate = p.receivedDate;
        this.checkInventory = p.checkInventory;
    }
    return UnpurifiedProbeLotParams;
}());
export { UnpurifiedProbeLotParams };
var CatalogPagePurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CatalogPagePurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, organism, geneSymbol, variant, designNumber, accession, sequence, probeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.organism = organism;
        this.geneSymbol = geneSymbol;
        this.variant = variant;
        this.designNumber = designNumber;
        this.accession = accession;
        this.sequence = sequence;
        this.probeSetSize = probeSetSize;
        this.params = params;
    }
    return CatalogPagePurifiedProbeLot;
}());
export { CatalogPagePurifiedProbeLot };
var CatalogOrganismCustomTargetPagePurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CatalogOrganismCustomTargetPagePurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, organism, customGeneSymbolName, customVariantName, customAccession, customSequence, customProbeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.organism = organism;
        this.customGeneSymbolName = customGeneSymbolName;
        this.customVariantName = customVariantName;
        this.customAccession = customAccession;
        this.customSequence = customSequence;
        this.customProbeSetSize = customProbeSetSize;
        this.params = params;
    }
    return CatalogOrganismCustomTargetPagePurifiedProbeLot;
}());
export { CatalogOrganismCustomTargetPagePurifiedProbeLot };
var CustomPagePurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CustomPagePurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, customOrganismName, customGeneSymbolName, customVariantName, customAccession, customSequence, customProbeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.customOrganismName = customOrganismName;
        this.customGeneSymbolName = customGeneSymbolName;
        this.customVariantName = customVariantName;
        this.customAccession = customAccession;
        this.customSequence = customSequence;
        this.customProbeSetSize = customProbeSetSize;
        this.params = params;
    }
    return CustomPagePurifiedProbeLot;
}());
export { CustomPagePurifiedProbeLot };
var CatalogColumnPurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CatalogColumnPurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, organism, geneSymbol, variant, designNumber, accession, sequence, probeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.organism = organism;
        this.geneSymbol = geneSymbol;
        this.variant = variant;
        this.designNumber = designNumber;
        this.accession = accession;
        this.sequence = sequence;
        this.probeSetSize = probeSetSize;
        this.params = params;
    }
    return CatalogColumnPurifiedProbeLot;
}());
export { CatalogColumnPurifiedProbeLot };
var CatalogOrganismCustomTargetColumnPurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CatalogOrganismCustomTargetColumnPurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, organism, customGeneSymbolName, customVariantName, customAccession, customSequence, customProbeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.organism = organism;
        this.customGeneSymbolName = customGeneSymbolName;
        this.customVariantName = customVariantName;
        this.customAccession = customAccession;
        this.customSequence = customSequence;
        this.customProbeSetSize = customProbeSetSize;
        this.params = params;
    }
    return CatalogOrganismCustomTargetColumnPurifiedProbeLot;
}());
export { CatalogOrganismCustomTargetColumnPurifiedProbeLot };
var CustomColumnPurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CustomColumnPurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, customOrganismName, customGeneSymbolName, customVariantName, customAccession, customSequence, customProbeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.customOrganismName = customOrganismName;
        this.customGeneSymbolName = customGeneSymbolName;
        this.customVariantName = customVariantName;
        this.customAccession = customAccession;
        this.customSequence = customSequence;
        this.customProbeSetSize = customProbeSetSize;
        this.params = params;
    }
    return CustomColumnPurifiedProbeLot;
}());
export { CustomColumnPurifiedProbeLot };
// tslint:disable-next-line:max-classes-per-file
var CatalogUnpurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CatalogUnpurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, organism, geneSymbol, variant, designNumber, accession, sequence, probeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.organism = organism;
        this.geneSymbol = geneSymbol;
        this.variant = variant;
        this.designNumber = designNumber;
        this.accession = accession;
        this.sequence = sequence;
        this.probeSetSize = probeSetSize;
        this.params = params;
    }
    return CatalogUnpurifiedProbeLot;
}());
export { CatalogUnpurifiedProbeLot };
// tslint:disable-next-line:max-classes-per-file
var CatalogOrganismCustomTargetUnpurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CatalogOrganismCustomTargetUnpurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, organism, customGeneSymbolName, customVariantName, customAccession, customSequence, customProbeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.organism = organism;
        this.customGeneSymbolName = customGeneSymbolName;
        this.customVariantName = customVariantName;
        this.customAccession = customAccession;
        this.customSequence = customSequence;
        this.customProbeSetSize = customProbeSetSize;
        this.params = params;
    }
    return CatalogOrganismCustomTargetUnpurifiedProbeLot;
}());
export { CatalogOrganismCustomTargetUnpurifiedProbeLot };
// tslint:disable-next-line:max-classes-per-file
var CustomUnpurifiedProbeLot = /** @class */ (function () {
    // tslint:disable-next-line:variable-name
    function CustomUnpurifiedProbeLot(_type, id, lotNumber, deactivated, reasonForDeactivation, hcrAmplifier, validation, customOrganismName, customGeneSymbolName, customVariantName, customAccession, customSequence, customProbeSetSize, params) {
        this._type = _type;
        this.id = id;
        this.lotNumber = lotNumber;
        this.deactivated = deactivated;
        this.reasonForDeactivation = reasonForDeactivation;
        this.hcrAmplifier = hcrAmplifier;
        this.validation = validation;
        this.customOrganismName = customOrganismName;
        this.customGeneSymbolName = customGeneSymbolName;
        this.customVariantName = customVariantName;
        this.customAccession = customAccession;
        this.customSequence = customSequence;
        this.customProbeSetSize = customProbeSetSize;
        this.params = params;
    }
    return CustomUnpurifiedProbeLot;
}());
export { CustomUnpurifiedProbeLot };
export var validationTypes = [
    "MI_VALIDATED",
    "VERIFIED_USER",
    "NORMAL_USER",
    "NOT_VALIDATED"
];
/**
 * Mirrors the backend ProbeLotTypeFilter enum — values are the Kotlin enum names, sent as-is
 * in the `probeLotType` query parameter.
 */
export var ProbeLotTypeFilter;
(function (ProbeLotTypeFilter) {
    ProbeLotTypeFilter["PAGE_PURIFIED"] = "PAGE_PURIFIED";
    ProbeLotTypeFilter["COLUMN_PURIFIED"] = "COLUMN_PURIFIED";
    ProbeLotTypeFilter["UNPURIFIED"] = "UNPURIFIED";
})(ProbeLotTypeFilter || (ProbeLotTypeFilter = {}));
export function isShortTarget(variantName) {
    if (variantName) {
        return variantName.toUpperCase().startsWith("VTWO") || variantName.toUpperCase().startsWith("SRP");
    }
    else {
        return false;
    }
}
//# sourceMappingURL=ProbeLotTablePage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ProbeLotTablePage.js
// module id = 78
// module chunks = 0